import styled from 'styled-components';
import GatsbyImage from 'gatsby-image';
import { mobileFirstMedia as media } from '../../config/theme';

import Container from '../container/container';

export const FullScreenContainer = styled(Container)`
  padding: 0;
  margin-bottom: 40px;

  @media (${media.xs}) {
    padding: 0 25px;
  }

  @media (${media.m}) {
    margin-bottom: 60px;
  }
`;

export const BannerGrid = styled.div`
  height: 220px;
  display: grid;
  grid-template-rows: 1fr var(--cropSize);
  background: lightgrey;
  position: relative;
  clip-path: polygon(
    100% 0,
    100% calc(100% - var(--cropSize)),
    calc(100% - var(--cropSize)) 100%,
    0 100%,
    0 0
  );

  @media (${media.s}) {
    grid-template-columns: 1fr 500px;
    clip-path: polygon(
      100% 0,
      100% calc(100% - 110px),
      calc(100% - 110px) 100%,
      110px 100%,
      0% calc(100% - 110px),
      0 0
    );
  }
`;

export const HeadingArea = styled.div`
  grid-row: 2 / 3;
  padding: 0 2.5em;
  font-size: 0.8em;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.primary};
  background: rgba(0, 0, 0, 0.7);

  @media (${media.s}) {
    grid-row: 1 / 3;
    grid-column: 2 / 3;
    align-items: flex-end;
    justify-content: flex-start;
    padding: 1.8em 2.5em;
  }
`;

export const HtmlContent = styled.div`
  font-size: 0.8em;

  & > h1,
  & > h2,
  & > h3,
  & > h4,
  & > h5,
  & > h6 {
    font-weight: inherit;
  }
`;

export const SectionContent = styled(HtmlContent)`
  display: none;

  @media (${media.m}) {
    display: block;
    font-size: 0.36em;
    padding-left: 1em;
    color: white;
    border-left: 2px solid ${({ theme }) => theme.colors.primary};
  }
`;

export const BackgroundImageArea = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
`;

export const BackgroundImage = styled(GatsbyImage)`
  width: 100%;
  height: 100%;

  @media (${media.m}) {
    & img {
      object-position: center -255px !important;
    }
  }
`;
